import {toPlainText} from "@portabletext/react";
import ContentConcept from "@/components/content/ContentConcept";
import {useEffect, useState} from "react";
import styles from "@/components/content/RelevantConcepts.module.css"

export default function RelevantConcepts({blocks}) {
  const [concepts, setConcepts] = useState([]);

  useEffect(() => {
    let conceptsArray = [];
    blocks.forEach((block) => {
      if (block._type === "block") {
        block.children.forEach((child) => {
          child.marks
            .map((mark) => block.markDefs.find((def) => def._key === mark))
            .forEach((def) => {
              if (def && def._type === "concept" && def.concept && def.concept.slug && def.concept.title) {
                conceptsArray.push(def.concept);
              }
            });
        });
      }
    });
    const uniqueConceptsArray = Array.from(new Set(conceptsArray.map(concept => concept.slug)))
      .map(slug => {
        return conceptsArray.find(concept => concept.slug === slug);
      });
    setConcepts(uniqueConceptsArray);
  }, [blocks]);

  return (
    concepts.length > 0 && (
      <div className={styles.section}>
        <div className={styles.sectionTitle}>Relevant concepts</div>
        <div className={styles.sectionContent}>
          {concepts.map((concept, index) => (
            <ContentConcept key={index} conceptRef={concept.slug} conceptType="pill">
              {concept.title}
            </ContentConcept>
          ))}
        </div>
      </div>
    )
  );
}
